'use strict';

let fetcher;

if (typeof fetch === 'undefined') {
    fetcher = require('node-fetch');
} else {
    fetcher = fetch;
}

class Dymo {
    constructor(options) {
        options = options || {};

        this.hostname = options.hostname || 'localhost';
        this.port = options.port || 41951;
        this.printerName = options.printerName;
    }

    get apiUrl() {
        return `https://${this.hostname}:${this.port}/DYMO/DLS/Printing`;
    }

    print(printerName, labelXml, labelSetXml='') {
        /*let label = `printerName=${encodeURIComponent(printerName.name)}&printParamsXml=&labelXml=${encodeURIComponent(labelXml)}&labelSetXml=${encodeURIComponent(labelSetXml)}`;
        console.log(printerName.name)
        console.log(labelXml)
        console.log(labelSetXml) */
        let _printerName = printerName;
        if (printerName.name) {
            _printerName = printerName.name;
        }
        window.dymo.label.framework.printLabel(_printerName, '', labelXml, labelSetXml);
      
        /* if (typeof process !== 'undefined' && process.env) {
            process.env.NODE_TLS_REJECT_UNAUTHORIZED = '0'; // TODO: Bundle the certificates.
        }

        return fetcher(`${this.apiUrl}/PrintLabel`,
            {
                method: 'POST',
                body: label,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then((response) => response.text())
            .then((result) => result); */
    }

    getPrinters() {
        //console.log(window.dymo.label.framework.init())
        //console.log(window.dymo.label.framework.checkEnvironment())
        let dymoPrinters = window.dymo.label.framework.getPrinters();
        console.log('dymoPrinters:' + dymoPrinters);
        if (dymoPrinters.length == 0) {
            //alert("No DYMO printers are installed. Install DYMO printers.");
            return;
        }

        return dymoPrinters;

        //return fetcher(`${this.apiUrl}/GetPrinters`)
        //    .then((response) => response.text());
    }
    
}

if (typeof module !== 'undefined' && module.exports) {
    module.exports = Dymo;
} else {
    window.Dymo = Dymo;
}



// WEBPACK FOOTER //
// ./src/lib/labels/dymojs/lib/index.js